import { css } from '@emotion/core'
import { CheckboxList, ListItem } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { toLocaleString } from '../../../util/DateUtil'
import { GroupLink } from '../../app/Links'
import DeleteGroupUserButton from './buttons/DeleteGroupUserButton'
import DemotePromoteUserButton from './buttons/DemotePromoteUserButton'

const secondaryDataCss = css`
  color: grey;
  font-size: 0.75rem;
  padding-top: 0;
  padding-inline-end: 0.75em;
  padding-bottom: 0;
  padding-inline-start: 0;
`

export default function UserGroupsList({ setCheckedGroups, memberSummaries, refreshUserGroupsDataAndControls }) {
  const { t } = useTranslation()

  return (
    <CheckboxList
      id="User Groups List"
      selectAllLabel={t('user.groups.selectAll', 'Select All ({ memberSummaryCount })', {
        memberSummaryCount: memberSummaries.length,
      })}
      onSelectionChange={setCheckedGroups}
    >
      {memberSummaries.map((memberSummary) => (
        <ListItem
          key={memberSummary.id}
          name={memberSummary.id}
          endElement={
            <>
              <div css={secondaryDataCss}>
                {t('user.groups.sharedReservations', 'Shared Reservations')}: {memberSummary.sharedReservationCount}
              </div>
              <DemotePromoteUserButton
                memberSummaries={[memberSummary]}
                refreshUserGroupsDataAndControls={refreshUserGroupsDataAndControls}
                single
              />
              <DeleteGroupUserButton
                memberSummaries={[memberSummary]}
                refreshUserGroupsDataAndControls={refreshUserGroupsDataAndControls}
                single
              />
            </>
          }
          primaryText={<GroupLink groupId={memberSummary.id} groupName={memberSummary.name} />}
          secondaryText={
            <span css={secondaryDataCss}>
              {`${t('joined', 'Joined')}: ${toLocaleString(new Date(memberSummary.createDate), false)} 
              • ${t('status.label', 'Status')}: ${t(
                `group.memberStatus.${memberSummary.memberStatus}`,
                memberSummary.memberStatus
              )} 
              • ${t('types', 'Types')}: ${memberSummary.groupTypes
                ?.map((type) => t(`group.type.${type}`, type))
                .join(', ')}`}
            </span>
          }
        />
      ))}
    </CheckboxList>
  )
}
